import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import BannerHoverx4 from './bannerComponents/BannerHoverx4';
import BannerSimpleX3 from './bannerComponents/BannerSimpleX3';
import Carousel3 from './bannerComponents/Carousel3';
import CarouselBanners from './bannerComponents/CarouselBanners';
import FeaturedSeventyFiveTwentyFive from './bannerComponents/FeaturedSeventyFiveTwentyFive';
import Featuredx2 from './bannerComponents/Featuredx2';
import FullWidthBanner from './bannerComponents/FullWidthBanner';
import OffersGalery from './bannerComponents/OffersGalery';
import VideoBanner from './bannerComponents/video';

/*
  Mapear las categorias a su correspondiente componente  en /bannersComponents/{componente}.js
*/

function getComponentByUbication(component, ubicacionObj, componentIndex, ubicacionIndex) {
  const componentsMap = {
    'destacado-2-lugares-75-25': FeaturedSeventyFiveTwentyFive,
    '2-banner-ancho-total': Featuredx2,
    'galeria-ofertas': OffersGalery,
    'banner-zocalo-x3': BannerSimpleX3,
    'carrusel-4-elementos': CarouselBanners,
    'carrusel-3-elementos': Carousel3,
    video: VideoBanner,
    'banner-simple-ancho-total': FullWidthBanner,
    'banner-hover-x4': BannerHoverx4,
  };

  const categoryName = component.categoria.nombre;
  const ubicationName = ubicacionObj?.nombre;
  const TheComponent = componentsMap[ubicationName];

  return (
    TheComponent !== undefined && (
      <TheComponent
        key={`${ubicationName}-${categoryName}-${component.banner[0].id}-${
          ubicacionObj.id
        }-${componentIndex}${ubicacionIndex !== undefined ? `-${ubicacionIndex}` : ''}`}
        data={component}
      />
    )
  );
}

function mapComponent(component, index) {
  if (component.categoria?.ubicacion) {
    return Array.isArray(component.categoria.ubicacion)
      ? component.categoria.ubicacion.map((ubicacion, ubicacionIndex) =>
          getComponentByUbication(component, ubicacion, index, ubicacionIndex),
        )
      : getComponentByUbication(component, component.categoria.ubicacion, index);
  }
}

export default function BannersComponents() {
  const { ready, error, categories } = useSelector((state) => state.bannersState);
  const renderComponents = useMemo(() => {
    if (ready & !error && categories) {
      let theComponents = [];
      categories
        .filter((component) => component.banner && component.banner.length > 0)
        .forEach((component, index) => {
          theComponents = theComponents.concat(mapComponent(component, index));
        });

      return theComponents;
    }
    return [];
  }, [ready, error, categories]);

  return (
    <div className="pt-10 pb-10">
      {!ready && (
        <div>
          <div className="flex bg-white shadow rounded px-10 py-16 animate-pulse mb-10" />
          <div className="flex bg-white shadow rounded px-10 py-16 animate-pulse" />
        </div>
      )}
      {ready && error && (
        <div className="flex text-center bg-white rounded px-10 py-16">
          No hay contenido para mostrar
        </div>
      )}
      {renderComponents}
    </div>
  );
}
